import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _Promise from '/app/node_modules/babel-runtime/core-js/promise';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';

var _this = this;

import { helpers } from 'vuelidate/lib/validators';

export var passwordComplexity = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(password) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', new _Promise(function (resolve) {
                            /** allow empty values */
                            if (!helpers.req(password)) return resolve(false);

                            /** at least 1 uppercase */
                            if (!/[A-Z]+/.test(password)) return resolve(false);

                            /** at least 1 lowercase */
                            if (!/[a-z]+/.test(password)) return resolve(false);

                            /** at least 1 number */
                            if (!/[0-9]+/.test(password)) return resolve(false);

                            /** al least 1 special character */
                            if (!/.*[!@#\$%^&*()\-_=+{};:,<.>\[\]]+.*/.test(password)) return resolve(false);

                            resolve(true);
                        }));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function passwordComplexity(_x) {
        return _ref.apply(this, arguments);
    };
}();


//////////////////
// WEBPACK FOOTER
// ./src/validators/password-complexity.js
// module id = ./src/validators/password-complexity.js
// module chunks = 0 1 2 3 4 6 7 8 9 10 11 12 14 15 16